import React, { useEffect } from "react";
import Slider from "react-slick"; // Assuming you are using react-slick
import "./StoreHomePage.css"
const OfferBannersCard = ({ card }) => {

  useEffect(() => {

  }, [])

  const settings = {
    dots: card?.cardData != null && card?.cardData.length > 1,
    infinite: card?.cardData != null && card?.cardData.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: "slick-dots white-dots", // Default class
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    
    
  };

  const navigatePage = (data) => {
    if (data.NavigationType === "3") {
      const currentQueryParams = window.location.search;
      if (data.FSN === "103") {
        const productId = data.FAI.productId;
        localStorage.setItem("productId", productId);
        window.location.href = `/product_detail_page${currentQueryParams}`; // productId query mein mat bhej, localStorage se utha lenge
      } else if (data.FSN === "125") {
        const type = data.FAI.type;
        const typeId = data.FAI.typeId;
        localStorage.setItem("type", type);
        localStorage.setItem("typeId", typeId);
        window.location.href = `/store_category_grid_page${currentQueryParams}`; // type, typeId query mein mat bhej, localStorage se utha lenge
      }
    }
  };
  return (
    <div style={{ width: "100%", flex: 1, padding: "16px" }}>
      <Slider {...settings}>
        {card?.cardData.map((image, index) => (
          <div
            onClick={() => navigatePage(image.data.onTap)}
            key={index}
            style={{
              width: "100%",
              position: "relative",
            }}
          >
            <img
              src={image.data.imageUrl}
              alt={`Offer ${index + 1}`}
              style={{
                maxWidth: "100%",
                margin: "0 auto",
                display: "block",
                objectFit: "fill",
                borderRadius: "8px",
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default OfferBannersCard;
